var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-date-picker',{attrs:{"first-day-of-week":1,"elevation":"15","range":"","color":"primary","header-color":"primary"},model:{value:(_vm.dates),callback:function ($$v) {_vm.dates=$$v},expression:"dates"}})
}
var staticRenderFns = []

export { render, staticRenderFns }